import React from 'react';
import { Container, Row ,Card,Col} from 'reactstrap';
import { ApplicationTitle, ToDoTitle } from '../../../Utils/Constants';

export default function ToDoContainer() {
    return (
        <>
        <Col sm={12}>
        <Card>
            <Container fluid className="todo-wrap">
                <Row>
                    {/* Embed the HTML form using an iframe */}
                    <iframe
                        src="http://localhost/medicity/client/template/indent_form.html"
                        style={{ width: '100%', height: '100vh', border: 'none' }}
                        title="Indent Form"
                    />
                </Row>
            </Container>
            </Card>
            </Col>
        </>
    );
}
